import { Component } from '@angular/core';
import { DeviceClient } from '../cms-bagha-api';

@Component({
    selector: 'app-event-list',
    templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss'],
  providers: [DeviceClient]
})
/** event-list component*/
export class EventListComponent {
  eventList: any;
  constructor(
    public dataService: DeviceClient) {

  }

  ngOnInit() {
    this.loadInitData();
    setTimeout(() => { window.location.reload()}, 50000);
  }
  loadInitData(): void {

    this.dataService.getEvents().subscribe(result => {
      this.eventList = result.data;
      console.log('Mahtab', this.eventList);
    });



  }
}
